import { connect } from 'react-redux';

import { actionCreators, selectors as orgSelectors } from 'dux/org';

import OrganizationCard from './OrganizationCard';

const mapStateToProps = (state) => ({
  org: orgSelectors.getOrgState(state),
});

const mapDispatchToProps = {
  updateOrg: actionCreators.updateOrg,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrganizationCard);
